import request from 'superagent';
import OAuth from '../services/oauth';

export default function setTooltipAsViewed(id) {
  return OAuth.apiRequest(
    request.del(`${OAuth.getApiPath()}/private/user_viewed_tooltips/${id}`),
    true,
  );
}
